// extracted by mini-css-extract-plugin
export var contact = "home-module--contact--DrQum";
export var headline = "home-module--headline--ydvzD";
export var helps = "home-module--helps--pOVyB";
export var hero = "home-module--hero--bbJgi";
export var home = "home-module--home--WE4Kj";
export var serves = "home-module--serves--ki3JF";
export var sub = "home-module--sub--pJ5Lv";